import dayjs from 'dayjs';
import store from '@/store';
import api from '@/api';
import { debounce } from 'lodash';

export default function (el) {
  if (el.path.includes('dashboard')) return;
  const { user = {}, menus = [] } = store.getters.userSelf;
  if (!menus.find((item) => el.path.includes(item.code))) return;
  const menu_id = menus.find((item) => el.path.includes(item.code)).id;
  const basicInfo = {
    ...el,
    menu_id,
    event_time: dayjs(Date.now()).format('YYYY-MM-DD HH:mm:ss'),
    appVersion: '1.0.0',
    report_app_name: 'cml-main-service',
    report_app_tenant: 'cml-main-service',
    report_app_ext_tenant: 'YJH',
    loginName: user.loginName,
    userName: user.name
  };
  debounce(() => {
    api.dict.batchReport([basicInfo]);
  }, 2000)();
}